import { gql } from 'urql';

export const UpdateCheckDeposit = gql`
  mutation UpdateCheckDeposit($input: UpdateRdcInput!) {
    updateRdc(input: $input) {
      ... on UpdateRdcSuccess {
        __typename
        id
        fundsAvailability
      }
      ... on UpdateRdcValidationError {
        __typename
        id
        fundsAvailability
        code
        title
        message
        errors {
          description
          severity
          isFixable
          isConfirmable
          fields
        }
      }
      ... on UpdateRdcError {
        __typename
        code
        title
        message
      }
    }
  }
`;

export default UpdateCheckDeposit;
